var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakePaymentRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66663C12.1167 2.6747 12.902 2.739 13.4142 3.25125C14 3.83704 14 4.77985 14 6.66547V10.6655C14 12.5511 14 13.4939 13.4142 14.0797C12.8284 14.6655 11.8856 14.6655 10 14.6655H6C4.11438 14.6655 3.17157 14.6655 2.58579 14.0797C2 13.4939 2 12.5511 2 10.6655V6.66547C2 4.77985 2 3.83704 2.58579 3.25125C3.09804 2.739 3.88332 2.6747 5.33333 2.66663",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 2.33337C5.33325 1.78109 5.78097 1.33337 6.33325 1.33337H9.66659C10.2189 1.33337 10.6666 1.78109 10.6666 2.33337V3.00004C10.6666 3.55233 10.2189 4.00004 9.66659 4.00004H6.33325C5.78097 4.00004 5.33325 3.55233 5.33325 3.00004V2.33337Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.66664L8 8.66664M8 8.66664L6 8.66664M8 8.66664L8 6.66663M8 8.66664L8 10.6666",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePaymentRecord);
export default __webpack_public_path__ + "static/media/makePaymentRecord.f744252dc0908dba0d8c29bd7106199d.svg";
export { ForwardRef as ReactComponent };